import { render, staticRenderFns } from "./intransfers.vue?vue&type=template&id=30d08186&scoped=true&"
import script from "./intransfers.vue?vue&type=script&lang=js&"
export * from "./intransfers.vue?vue&type=script&lang=js&"
import style0 from "./intransfers.vue?vue&type=style&index=0&id=30d08186&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d08186",
  null
  
)

export default component.exports